import _ from "underscore";
import React from 'react';
import PropTypes from "prop-types";
import Pagination from 'rc-pagination';
import Select from 'rc-select';
import localeInfo from 'rc-pagination/lib/locale/en_US';
import CircularProgress from 'material-ui/CircularProgress';
import IconButton from 'material-ui/IconButton';
import ActionHome from 'material-ui/svg-icons/navigation/refresh';

import axios from "axios/index";
axios.defaults.headers.common['Authorization'] = "Basic YWRtaW46YWRtaW4=";
import URL from 'url-parse';
import 'rc-pagination/assets/index.css';
import 'rc-select/assets/index.css';

function getURLSearchParamsAsObject(u) {
    const parsed = new URL(u);
    const query = parsed['query'].replace('?', '');

    if(query === '') return null;

    const queryP = {};

    _.each(query.split("&"), function (item) {
        const v = item.split("=");
        queryP[v[0]] = v[1];
    }, this);
    return queryP;

}

function addParamsToUrl(u, params) {

    const parsed = new URL(u);
    const newQueryParams = [];
    let query = '';
    const queryP = getURLSearchParamsAsObject(u);

    const destination = _.omit(_.extend({}, queryP, params), function(value) {
        return value === -1;
    });

    _.each(_.pairs(destination), function(key) {
        newQueryParams.push(`${key[0]}=${key[1]}`);
    });

    if(newQueryParams.length > 0) {
        query = '?' + newQueryParams.join('&');
    }

    parsed.set('query', query);

    return parsed.toString().replace(parsed.origin, '');
}

/**
 * @TODO. Very complicated component. Does not fit SOLID. Reactor it
 */
export default class PaginationContentWrapper extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            content: [],
            pagination: null,
            current_url: this.props.url,
            filters: null,

            activePage: 15
        };

        this.fetchContent                = this.fetchContent.bind(this);
        this.onPagerChange               = this.onPagerChange.bind(this);
        this.splitContentAndFilters      = this.splitContentAndFilters.bind(this);
        this._getRefreshBtn              = this._getRefreshBtn.bind(this);
        this._filterChanged              = this._filterChanged.bind(this);
        this._contentPreLoaded           = this._contentPreLoaded.bind(this);
        this._contentAfterLoaded         = this._contentAfterLoaded.bind(this);
        this._filter                     = this._filter.bind(this);
        this._pager                      = this._pager.bind(this);
    }

    componentDidMount() {
        this.fetchContent();
    }

    fetchContent(url = this.state.current_url) {
        const self = this;

        self.setState({
            loading: true
        });


        return axios.get(url)
            .then(response => {
                const cont = self.splitContentAndFilters(response.data.content);

                self.setState({
                    loading: false,
                    content: cont.content,
                    filters: cont.filters,
                    pagination: response.data.pagination,
                    current_url: url
                });

            }).catch(function () {

                //@TODO Add global error trigger here
                self.setState({
                    loading: false,
                    content: null,
                    pagination: null,
                    filters: null
                });
            });
    }

    splitContentAndFilters(response) {
        let content = null;
        const filters = {};

        if(_.isArray(response)) {
            return {
                content: response,
                filters: null
            }
        }

        _.each(response, function (res, filterName) {

            if(_.isString(res)) {
                filters[filterName] = res;
            } else if(_.isArray(res) || _.isObject(res)) {
                const firstElement = _.first(res);
                if(_.isUndefined(firstElement) || _.isString(firstElement)) {
                    filters[filterName] = res;
                } else {
                    content = res;
                }
            }
        }, this);

        return {
            content: _.isNull(content) ? [] : content,
            filters: filters
        };
    }

    onPagerChange(current, pageSize) {
        if (this.state.pagination.page !== current || this.state.pagination.limit !== pageSize) {

            this._filterChanged({
                'limit': pageSize,
                'page': current
            });
        }
    }

    _filterChanged(params) {
        const url = addParamsToUrl(this.state.current_url, params);

        this.fetchContent(url);
    }

    render() {

        const content = this.state.loading ? this._contentPreLoaded() : this._contentAfterLoaded();

        return (
            <div>
                {this._filter()}

                {!this.state.loading && this.state.pagination && this._pager()}
                {!this.state.loading && this._getRefreshBtn()}

                {content}

                {!this.state.loading && this.state.pagination && this._pager()}
            </div>
        );
    }

    _filter() {
        const filtersProps = {};
        _.extend(filtersProps, {onChange: this._filterChanged, ...this.state.filters}, getURLSearchParamsAsObject(this.state.current_url));

        return React.Children.map(this.props.filter, f => {
            return React.cloneElement(f, filtersProps);
        });
    }

    _contentPreLoaded() {
        return <CircularProgress size={30} thickness={3}/>;
    }

    _contentAfterLoaded() {
        return React.Children.map(this.props.children, child => {
            return React.cloneElement(child, {
                url: this.props.url,
                content: this.state.content,
                pagination: this.state.pagination,
                fetchContent: this.fetchContent
            });
        });
    }

    _getRefreshBtn() {

        if(!this.props.refreshBtn) return null;

        const styles = {
            largeIcon: {
                width: 30,
                height: 30
            },
            large: {
                width: 80,
                height: 80,
                padding: 10
            },
        };

        return (<IconButton onClick={() => {this.fetchContent(this.state.current_url)}} iconStyle={styles.largeIcon} style={styles.large}><ActionHome /></IconButton>);
    }



    _pager() {
        return   <div style={{margin: 15}}>
            <Pagination
                hideOnSinglePage
                selectComponentClass={Select}
                showSizeChanger
                showTitle={false}
                defaultCurrent={1}
                total={this.state.pagination.items}
                pageSize={this.state.pagination.limit}
                current={this.state.pagination.page}
                locale={localeInfo}
                onShowSizeChange={this.onPagerChange}
                onChange={this.onPagerChange}/>
        </div>;
    }


}

PaginationContentWrapper.propTypes = {
    url: PropTypes.string.isRequired,
    refreshBtn: PropTypes.bool.isRequired,
};

PaginationContentWrapper.defaultProps = {
    refreshBtn: true
};


// WEBPACK FOOTER //
// ./assets/src/js/factory/PaginationContentWrapper.jsx